// V4.9 Phase 7 — Suspicious Listings Quarantine API client.
import { apiClient as api } from "./client";

export async function fetchSuspectQueue(params = {}) {
  const { data } = await api.get("/admin/suspect-listings/queue", { params });
  return data;
}

export async function runSuspectScan({ vertical, apply = true, limit = 200000 } = {}) {
  const { data } = await api.post("/admin/suspect-listings/scan", null, {
    params: { ...(vertical ? { vertical } : {}), apply, limit },
  });
  return data;
}

export async function approveSuspect(ulid, note) {
  const { data } = await api.post(`/admin/suspect-listings/${ulid}/approve`, { note });
  return data;
}

export async function rejectSuspect(ulid, note) {
  const { data } = await api.post(`/admin/suspect-listings/${ulid}/reject`, { note });
  return data;
}

export async function correctSuspect(ulid, payload) {
  const { data } = await api.post(`/admin/suspect-listings/${ulid}/correct`, payload);
  return data;
}
